<template>
  <div class="f14 bgF0EFF4 ">
    <!-- banner & 公告 -->
    <div class="pr" @mouseover="onHover" @mouseleave="onLeave">
      <Carousel :autoplay="carouselParam.autoplay" :height="carouselParam.h" v-model="carouselParam.active" :loop="carouselParam.loop" :autoplay-speed="carouselParam.autoplaySpeed" :dots="carouselParam.dots" :trigger="carouselParam.trigger" style="height: 230px" v-if="banners.length > 0">
        <CarouselItem v-for="item in banners" :key="item.code">
          <a :href="item.linkUrl" target="_blank" v-if="item.linkUrl">
            <div class="demo-carousel h100b w100b" style="overflow: hidden;">
              <div class="cp" :style="'height:230px;background: url('+ getImgUrl(item.picName) +') no-repeat center center;background-size:cover;'"></div>
            </div>
          </a>
          <div class="demo-carousel h100b w100b" style="overflow: hidden;" v-else>
            <div class="cp" :style="'height:230px;background: url('+ getImgUrl(item.picName) +') no-repeat center center;background-size:cover;'"></div>
          </div>
        </CarouselItem>
      </Carousel>

      <div v-else class="h27 bgf2f2f2"></div>

      <div class="main_width main_notice_top fStart" style="z-index:1;">
        <p class="w15b c999 pl30 tl">最新成单</p>
        <div class="w85b" @mouseover="marqueePause = true" @mouseleave="marqueePause = false">
          <marquee-text :duration="20" :repeat="5" :paused="marqueePause">
            <p class="dl mr65" v-for="(list, index) in param.orderList" :key="index">{{getOrderText(list)}}</p>
          </marquee-text>
        </div>
      </div>
    </div>

    <!-- 商票 & 银票 & 报价 -->
    <div class="main_bg">
      <div class="main_width m0a tl">
        <!-- 银票商票tab选择 -->
        <tabTicket :bestRate="param.rateTab.y"></tabTicket>

        <guide-video></guide-video>

        <div class="main_rate fStart mt30 jdFont">
          <div class="main_rate_tab dCC">
            <div @click="handleRate(1)" class="mb60 fSpace aic" :class="[param.isActive == 1 ? 'active' : '']">
              <p>银行承兑汇票贴现<br>今日报价</p>
              <span></span>
            </div>

            <!-- <div @click="handleRate(2)" class="fSpace aic" :class="[param.isActive == 2 ? 'active' : '']">
              <p>商业承兑汇票<br>今日报价</p>
              <span></span>
            </div> -->
          </div>

          <div class="w100b bgfff h440">
            <div v-show="param.isActive == 1 ? true : false">
              <Table :loading="param.rateTab.loading" :columns="param.rateTab.header_y" :data="param.rateTab.y" :show-header="false"></Table>

              <router-link to="/DiscountRate">
                <div class="tc bgfff hl58 c333 f12 cp">查看更多贴现利率</div>
              </router-link>
            </div>
            <div v-show="param.isActive == 2 ? true : false">
              <Table :loading="param.rateTab.loading" :columns="param.rateTab.header_s" :data="param.rateTab.s" :show-header="false"></Table>

              <router-link to="/DiscountRate">
                <div class="tc bgfff hl58 c333 f12 cp">查看更多贴现利率</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 资讯列表 & 公告列表 -->
    <div class="bgFAFAFC tl">
      <div class="main_width m0a pt10 pb46 fSpace informationAndNotice">
        <div class="w60b mr15">
          <p class="title clearfix">
            <span>热门行业资讯</span>

            <router-link class="fr c666 mt8" to="/Information">
              <span @mouseover="param.informationHover = true" @mouseleave="param.informationHover = false">
                <Icon class="va-6 mr3" :color="param.informationHover ? '#E1241A' : '#999'" size=24 type="ios-more" />
                查看更多
              </span>
            </router-link>
          </p>
          <ul class="bgfff bs13 plr40 ptb10">
            <li class="bbE5E5E5 ptb15" v-for="list in param.information" :key="list.infoId">
              <router-link :to="{path: '/InformationDetail', query: { id: list.infoId, title: list.title }}">
                <!-- <router-link :to="{path: '/InformationDetail', query: { id: list.infoId, title: list.title, content: textSlice(list.bodyText) }}"> -->
                <p class="f16 hl20 c333">
                  <Icon v-show="list.titleType == '4' || list.titleType == '5'" size=16 color="#377FFC" type="logo-youtube" />
                  <Icon v-show="list.titleType == '2' || list.titleType == '3'" size=16 color="#F46200" type="md-image" />
                  {{list.title}}
                </p>

                <div class="fSpace c999 hl20">
                  <p>{{list.releaseTime}}</p>
                  <p class="w80">
                    <Icon color="#999" size=14 type="md-eye" />
                    {{list.viewNumPv}}
                  </p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="w40b">
          <p class="title"><span>快贴宝平台公告</span></p>
          <ul class="bgfff bs13 plr40 ptb10">
            <li class="bbE5E5E5 ptb15" v-for="list in param.notice" :key="list.noticeId">
              <router-link :to="{path: '/Notice/Detail', query: { id: list.noticeId, title: list.title, content: textSlice(list.noticeInfo) }}">
                <p class="f16 hl20 c333 text-overflow">{{list.title}}</p>
                <p class="c999 hl20">{{list.publishDate ? list.publishDate.split(' ')[0] : ''}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 合作机构 -->
    <div class="main_width m0a pt33 pb10 tl">
      <p class="title_hzjg">
        <i></i>
        <span>快贴宝合作机构</span>
        <i></i>
      </p>

      <div class="mb45" :class="[organization.length == 3 ? 'fSpace' : 'dCC']" v-for="(organization, index) in param.organization" :key="index">
        <div class="bs31 bgfff w32b h124 plr34 pt50 pr" :class="organ.logo && 'wow bounceInLeft'" v-for="organ in organization" :key="organ.logo" :style="(!organ.logo) && 'visibility: hidden;'">
          <img class="w120 h38 pa t-15 palx" :src="'../../../static/img/img_home/' + organ.logo" alt="">
          <p class="l17">{{organ.context}}</p>
        </div>
      </div>
    </div>

    <!-- 底部广告 -->
    <section id="indexBottomBg" v-if="indexBottom">
      <img :class="indexBottomAnimate ? 'logoAnimateHide' : 'logoAnimateShow'" ref="indexBottomLogo" @click="bottomShow()" :src="getImgUrl(indexBottom.picLogoName)" alt="">

      <div :class="indexBottomAnimate ? 'imgAnimateShow' : 'imgAnimateHide'">
        <div @click="toLinkUrl(indexBottom.linkUrl ? indexBottom.linkUrl : '')" :class="indexBottom.linkUrl?'cp':''">
          <div><img :src="getImgUrl(indexBottom.picName)" alt=""></div>
        </div>

        <span @click="bottomHide()"></span>
      </div>
    </section>
  </div>
</template>

<script>
import store from '@/store/store';
import MarqueeText from 'vue-marquee-text-component';
import tabTicket from "./tab-ticket.vue"
import GuideVideo from "./GuideVideo.vue"
import { queryShowIndexQuote } from '@/api/discountBankQuote.js'
import { queryBest } from '@/api/discountBankQuote.js'

let _this = '';

let _header = [
  {
    title: 'bankName',
    render: (h, params) => {
      return h('div', { attrs: { class: 'fStart' } }, [
        h('span', { attrs: { class: 'mr3 wh20 dl', style: _this.logoStyle(params.row.bankIcon) } }, ''),
        h('div', [
          h('p', { attrs: { class: 'c333 f14 fb' } }, params.row.bankName),
          h('p', { attrs: { class: 'c999 f12' } }, '贴入行'),
        ]),
      ]);
    }
  },
  {
    title: 'bankType',
    render: (h, params) => {
      return h('div', [
        h('p', { attrs: { class: 'c333 f14' } }, params.row.bankType),
        h('p', { attrs: { class: 'c999 f12' } }, '承兑人分类'),
      ])
    }
  },
  {
    title: 'piaoMoney',
    render: (h, params) => {
      return h('div', [
        h('p', { attrs: { class: 'c333 f14' } }, '大于' + params.row.piaoMoney),
        h('p', { attrs: { class: 'c999 f12' } }, '票面金额'),
      ])
    }
  },
  {
    title: 'rate',
    render: (h, params) => {
      return h('div', [
        h('p', { attrs: { class: 'cE1241A fb' } }, [
          h('span', { attrs: { class: 'f24 fb' } }, params.row.rate),
          h('span', { attrs: { class: 'f14 fb' } }, '%'),
        ]),
        h('p', { attrs: { class: 'c999 f12' } }, '贴现年化利率'),
      ])
    }
  },
]

export default {
  store, // 引用
  name: "homeMenu",
  components: {
    MarqueeText,
    tabTicket,
    GuideVideo
  },
  data () {
    return {
      carouselParam: {
        active: 0,
        autoplay: true,   // 	是否自动切换
        autoplaySpeed: 3000,   // 	切换时间（毫秒）
        loop: true,        // 是否开启循环
        h: 'auto',
        paramList: [],       // 轮播图参数
        dots: "none",
        trigger: "hover",
      },
      banners: [],

      marqueePause: false,

      param: {
        isHover: 1, // 选择 1-银票 2-商票

        orderList: '',  // 跑马灯数据

        // 银票信息
        tip: ['提交票面', '获取报价', '操作网银', '银行回款', '获取贴凭'],

        // 商票信息
        tip1: ['提交票面', '获取报价', '上传贸易背景资料', '票据背书', '款项到账'],

        isActive: 1,  // tab选择 1-银票利率 2-商票利率
        rateTab: {
          loading: true,
          header_y: _header,
          header_s: _header,
          y: [],
          s: []
        },

        // 行业资讯
        informationHover: false,
        information: [],

        // 平台公告
        notice: [],

        // 合作机构
        organization: [
          [
            {
              logo: 'Logoz_huarunbank@2x.png',
              context: '珠海华润银行成立于1996年12月，是具有一级法人资格的城市商业银行。2010年1月，华润股份有限公司和珠海市政府对珠海市商业银行成功实施战略重组，现注册资本达60.43亿元。'
            },
            {
              logo: 'Logoz_pinganbank.png',
              context: '平安银行，全称平安银行股份有限公司，是中国平安保险(集团)股份有限公司控股的一家跨区域经营的股份制商业银行，为中国大陆12家全国性股份制商业银行之一。'
            },
            {
              logo: 'logo_wz.jpg',
              context: '腾讯牵头发起设立的中国首家互联网银行、微众银行线上服务平台。'
            },
            /* {
              logo: 'logo_hc@2x.png',
              context: '慧聪集团是国内领先的产业互联网集团之一，是香港联合交易所有限公司（联交所）主板上市公司。'
            },
            {
              logo: 'logo_cib@2x.png',
              context: '兴业数金是兴业银行集团旗下金融科技子公司。作为集团高科技内核和创新孵化器，负责兴业银行集团科技研发和数字化创新工作。'
            }, */
          ],
          [
            {
              logo: 'logo_bluebank@2x.png',
              context: '山东省首家民营银行，山东省金融改革创新示范点，倾力打造线上线下融合发展的O2O类互联网银行。'
            },
            {
              logo: 'log0_chongqingfm@2x.png',
              context: '重庆富民银行是经中国银监会批准成立的中西部第一家民营银行，也是常态化审批后成立的第一家民营银行。'
            },
            {
              logo: 'Logoz_sanxiangbank.png',
              context: '三湘银行是湖南省和中部地区首家民营银行，着力打造产业银行、资产管理银行、数字银行、便捷银行 。'
            }
          ],
          [
            {
              logo: 'logo_MYbank_a@2x.png',
              context: ' 网商银行是由蚂蚁金服作为大股东发起设立的中国第一家核心系统基于云计算架构的商业银行。它作为银监会批准的中国首批5家民营银行之一。'
            },
            {
              logo: 'logo_yunnanht@2x.png',
              context: '红塔村镇银行是由云南红塔银行作为主发起人，联合地方财政、非银行企业法人和自然人共同投资组建的新型农村金融机构。'
            },
            {
              logo: 'Logoz_bank@2x.png',
              context: '武汉众邦银行定位为专注服务个人小微的互联网交易银行，由卓尔控股、当代集团、壹网通科技、钰龙集团、奥山投资、法斯克能源等六家企业联合发起设立。'
            },
          ]
        ],
      },
      newMsg: [], // 获取马蜂窝信息

      indexBottom: '',  // 底部广告信息
      indexBottomAnimate: false, // 是否弹出广告，true展开，false收缩
    }
  },
  created () {
    _this = this;
    // console.log("home", this.$store.state.menuList);
    this.getInformation();  // 获取行业资讯
    this.getRate(); // 获取利率
    this.getNotice(); // 获取平台公告
    this.getBottom(); // 初始化底部广告信息
    this.getBannerList(); // 初始化顶部广告信息
    this.getOrderList(); // 获取平台公告

    // 如果没有登录则展示登录弹框
    if (!this.fungetLogin() && this.$route.params.login) {
      this.showLoginPopus();
    }
  },
  mounted () {
    this.getNewMsg(); // 马蜂窝显示

    /* 定时获取信息
     * 页面刷新加载完成后10秒钟开始显示第一次，展示时长15s（每次展示条数不超过6条），30s再获取一次（只显示新的，没看过的）
     */
    this.newMsgTimer = setInterval(function () {
      _this.getNewMsg();
    }, 1000 * 60 * 5)

    this.indexBottomAnimate = true;

    if (!this.isIE()) {
      this.$nextTick(() => { // 在dom渲染完后,再执行动画
        // 初始化动画
        let wow = new this.WOW({
          live: false
        })
        wow.init();
      })
    }
  },
  destoryed () {
    this.newMsgTimer ? clearInterval(this.newMsgTimer) : '';
    console.log('销毁定时', this.newMsgTimer);
  },
  methods: {
    // banner跳转
    toUrl (url) {
      url ? window.open(url, '_blank') : '';
    },
    // 获取顶部banner图
    getBannerList () {
      this.sendGet({
        url: '/web/advert/advertimg/query/ext/ktb_banner',
        successCallback: (result) => {
          console.log(result.data.data, 'ktb_banner');
          _this.banners = result.data.data;
          _this.carouselParam.autoplaySpeed = result.data.data[0].scrollSeconds ? result.data.data[0].scrollSeconds * 1000 : _this.carouselParam.autoplaySpeed;
        },
        failCallback: (result) => {
          console.log("获取信息失败", result.message);
        }
      })
    },
    // 利率选择
    handleRate (num) {
      if (this.param.isActive == num) {
        return;
      }

      // console.log(num);
      this.param.isActive = num;
      if (num == 2 && this.param.rateTab.s.length == 0) {
        this.getRate();
      }
    },
    async getRate (arr) {
      this.param.rateTab.loading = true;
      // const list = await queryShowIndexQuote();
      // const handleList = list.map((item) => {
      //   let acceptorTypeStr;
      //   acceptorTypeStr = this.formatDict(item.acceptorType, 'acceptorLevel')
      //   return {
      //     bankName: item.bankName,
      //     bankType: acceptorTypeStr,
      //     piaoMoney: item.billAmountMin.div(10000) + "万",
      //     rate: item.discountRate ? item.discountRate.mul(100).toFixed(2) : '0.00',
      //     bankIcon: item.bankCode
      //   }
      // })
      // this.param.isActive == 1 ? this.param.rateTab.y = handleList : this.param.rateTab.s = handleList;
      // this.param.rateTab.loading = false;

      const cp = []
      const obj = {}
      const res = await queryBest();
      function setData (arr) {
        const list = []
        arr.map(item => {
          list.push(qSort(item.arrayList))
        })
        return list
      }
      // 排序
      function qSort (arr) {
        //声名并初始化左边的数组和右边的数组
        let left = [], right = [];
        // 使用数组第一个元素作为基准值
        let base = arr[0];
        //当数组长度只有1或者为空时，直接返回数组，不需要排序
        if (arr.length <= 1) return arr;
        //进行遍历
        for (let i = 1; i < arr.length; i++) {
          if (arr[i].discountRate <= base.discountRate) {
            //如果小于基准值，push到左边的数组
            left.push(arr[i])
          } else {
            //如果大于基准值，push到右边的数组
            right.push(arr[i]);
          }
        }
        //递归并且合并数组元素
        return [...qSort(left), base, ...qSort(right)][0];
      }
      res.cuDiscountRate.map(item => {
        cp.push(...setData(res.cuDiscountRate.filter(e => item.bankLevel == e.bankLevel)))
      })

      // 去重
      const newList = cp.reduce((item, next) => {
        obj[next.bankLevel] ? '' : obj[next.bankLevel] = true && item.push(next)
        return item
      }, [])
      console.log(newList)

      const handleList = newList.map((item) => {
        let acceptorTypeStr;
        acceptorTypeStr = this.formatDict(item.acceptorType, 'acceptorLevel')
        return {
          bankName: item.bankName,
          bankType: acceptorTypeStr,
          piaoMoney: item.billAmountMin.div(10000) + "万",
          rate: item.discountRate ? item.discountRate.mul(100).toFixed(2) : '0.00',
          bankIcon: item.bankCode
        }
      })
      this.param.isActive == 1 ? this.param.rateTab.y = handleList : this.param.rateTab.s = handleList;
      this.param.rateTab.loading = false;
      // })

      // 获取京东配置
      /* this.sendGet({
        url: '/web/discountPlatform/bankQuote',
        tip: false
      }, (result) => {
        let quoteList = result.data.data ? JSON.parse(this.HTMLDecode(result.data.data.bankQuoteJson)) : [];
        // console.log(quoteList);
        let arr = [];
        for (let i in quoteList) {
          if (quoteList[i].data.mtBank == "FM") {
            // 富民
            arr.push({
              bankName: '重庆富民银行',
              bankType: quoteList[i].data.body[2].acceptorName,
              piaoMoney: quoteList[i].data.amountList[1].start.div(10000).toFixed(0) + "万",
              rate: this.HTMLDecode(quoteList[i].data.body[2].rateList[1].rate),
              bankIcon: "FM"
            });
            arr.push({
              bankName: '重庆富民银行',
              bankType: quoteList[i].data.body[5].acceptorName,
              piaoMoney: quoteList[i].data.amountList[1].start.div(10000).toFixed(0) + "万",
              rate: this.HTMLDecode(quoteList[i].data.body[5].rateList[1].rate),
              bankIcon: "FM"
            });
          } else if (quoteList[i].data.mtBank == "WHLH") {
            // 蓝海
            arr.push({
              bankName: '蓝海银行',
              bankType: quoteList[i].data.body[1].acceptorName,
              piaoMoney: quoteList[i].data.amountList[1].start.div(10000).toFixed(0) + "万",
              rate: this.HTMLDecode(quoteList[i].data.body[1].rateList[1].rate),
              bankIcon: "WHLH"
            });
            arr.push({
              bankName: '蓝海银行',
              bankType: quoteList[i].data.body[5].acceptorName,
              piaoMoney: quoteList[i].data.amountList[0].start.div(10000).toFixed(0) + "万",
              rate: this.HTMLDecode(quoteList[i].data.body[5].rateList[0].rate),
              bankIcon: "WHLH"
            });
          } else if (quoteList[i].data.mtBank == "YNHT") {
            // 红塔
            arr.push({
              bankName: '云南红塔银行',
              bankType: quoteList[i].data.body[6].acceptorName,
              piaoMoney: quoteList[i].data.amountList[0].start.div(10000).toFixed(0) + "万",
              rate: this.HTMLDecode(quoteList[i].data.body[6].rateList[0].rate),
              bankIcon: "YNHT"
            });
          }
        }
 
        this.param.isActive == 1 ? this.param.rateTab.y = arr : this.param.rateTab.s = arr;
        this.param.rateTab.loading = false;
      }) */



    },

    // 获取行业资讯
    getInformation () {
      this.sendGet({
        url: '/web/informationView/platform/ktb',
        data: { page: 1, rows: 6, sidx: 'release_time', sord: 'desc' }
      }, (result) => {
        this.param.information = result.data.data;
      }, (result) => {
        // console.log("其他回调", result);
      })
    },

    // 获取平台公告
    getOrderList () {
      // billAmountStart: '10000',
      this.sendGet({
        url: '/web/discount-order/newest-success',
        data: { rows: 10 }// desc-降序  asc-升序
      }, (result) => {
        console.log(result.data.data, '=====');
        this.param.orderList = result.data.data;
      }, (result) => {
        // console.log("其他回调", result);
      })
    },
    getOrderText (item) {
      const corpName = item.discountCorpName
      const billAmount = Math.floor(item.billAmount.div(10000))
      return corpName.slice(0, 2) + '********' + corpName.slice(corpName.length - 2) + '成功贴现' + billAmount + '万'
    },

    // 获取平台公告
    getNotice () {
      this.sendGet({
        url: '/web/notice/platform/ktb',
        data: { page: 1, rows: 6, sord: 'desc', sidx: 'publish_date' }// desc-降序  asc-升序
      }, (result) => {
        this.param.notice = result.data.data;
      }, (result) => {
        // console.log("其他回调", result);
      })
    },

    // 马蜂窝
    // 获取马蜂窝信息
    getNewMsg () {
      console.log('获取马蜂窝', new Date(), new Date().getTime());
      this.sendGet({
        url: '/web/auth/getNewestMsg',
        data: { key: 'index_message_discount' },
        tip: false
      }, (result) => {
        console.log('马蜂窝接口获取：', result);
        this.newMsg = this.newMsg.concat(result.data.data);
        this.handleMsg();
      }, (result) => {
        // console.log("其他回调", result);
      })
    },

    // 处理马蜂窝
    open (nodesc) {
      console.log('马蜂窝显示：', nodesc);
      // 全局设置
      this.$Notice.config({
        top: 80
      })

      this.$Notice.open({
        title: '',
        duration: nodesc.duration,  // 自动关闭的延时，单位秒，不关闭可以写 0
        name: nodesc.time,  // 当前通知的唯一标识
        desc: _this.HTMLDecode(nodesc.content)
      });
    },
    handleMsg () {
      if (this.newMsg.length == 0) return;

      let newMsgTime = this.getCookie('newMsgTime');
      newMsgTime = newMsgTime ? newMsgTime.split('=')[1].split(',') : [];

      // 判断显示过的内容，如果显示过则删除，否则显示内容
      for (let [index, item] of this.newMsg.entries()) {
        // console.log('newMsg 数组循环', index, item);

        let findIn = newMsgTime.find(function (value) {
          return value == item.time
        })

        if (findIn) {
          _this.newMsg.splice(index, 1);
        } else {
          item.duration = 5 * (index + 1)
          newMsgTime.push(item.time);
          _this.open(item);  // 显示内容
        }
      }

      // console.log('_this.newMsg', _this.newMsg, 'newMsgTime', newMsgTime);

      document.cookie = "newMsgTime=" + newMsgTime.join(",");

      if (this.newMsg.length > 6) {
        this.newMsg.splice(0, this.newMsg.length - 6);
      }
    },

    // 鼠标移入停止轮播
    onHover (e) {
      this.carouselParam.autoplay = false
      // console.log('--------', e, this.carouselParam.active);

    },
    // 鼠标移出继续轮播
    onLeave (e) {
      this.carouselParam.autoplay = true
      // console.log('--------onLeave', e, this.carouselParam.active);

    },

    // 底部广告
    getBottom () {
      this.sendGet({
        url: '/web/advert/advertimg/query/ktb_index_bottom',
        successCallback: (result) => {
          this.indexBottom = result.data.data

          // 获取localStorage信息
          this.indexBottomStorage = local_Storage_get('indexBottom')
          if (this.indexBottomStorage) this.indexBottomStorage = JSON.parse(this.indexBottomStorage)

          // 判断当前的img是否与上一次打开页面的img一致
          this.indexBottomStorageImg = result.data.data.picName

          if (!this.indexBottomStorage || (this.indexBottomStorage && (this.indexBottomStorage.status === 'show' || this.indexBottomStorage.img !== this.indexBottomStorageImg))) {
            this.indexBottomStorage = {
              status: 'show',
              img: this.indexBottomStorageImg
            }

            local_Storage_set('indexBottom', JSON.stringify(this.indexBottomStorage))

            this.bottomShow()
          } else {
            this.bottomHide()
          }
        }
      })
    },
    bottomShow () {
      this.indexBottomAnimate = true

      if (this.indexBottomStorage && this.indexBottomStorage.status !== 'show') {
        this.indexBottomStorage = {
          status: 'show',
          img: this.indexBottomStorageImg
        }

        local_Storage_set('indexBottom', JSON.stringify(this.indexBottomStorage))
      }
    },
    bottomHide () {
      this.indexBottomAnimate = false

      if (this.indexBottomStorage && this.indexBottomStorage.status !== 'hide') {
        this.indexBottomStorage = {
          status: 'hide',
          img: this.indexBottomStorageImg
        }

        local_Storage_set('indexBottom', JSON.stringify(this.indexBottomStorage))
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.jdFont
  font-family: 'jd-fonts'
ul, li
  list-style: none
.text-overflow
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
wh(n)
  width: n
  height: n
hl(n)
  height: n
  line-height: n
btb(n)
  border-top: n solid transparent
  border-bottom: n solid transparent
blr(n)
  border-left: n solid transparent
  border-right: n solid transparent
vendor(prop, n)
  -webkit-{prop}: n
  -moz-{prop}: n
  -ms-{prop}: n
  -o-{prop}: n
  {prop}: n
.bablock
  display: block
  width: 0px
  height: 0px
  content: ''
  position: absolute
.paty
  position: absolute
  top: 50%
  vendor('transform', translateY(-50%))
.palx
  position: absolute
  left: 50%
  vendor('transform', translateX(-50%))
.main_notice_top
  @extend .palx
  bottom: -15px
  hl(34px)
  background-color: #E7E8EB
  border-top-left-radius: 15px
  border-top-right-radius: 15px
  &::after
    display: block
    content: ''
    width: 100%
    height: 14px
    background: linear-gradient(180deg, rgba(210, 210, 210, 1), rgba(234, 235, 237, 1))
    position: absolute
    bottom: -14px
    left: 0px
.main_bg
  background: url('~@/assets/img/home/bg@2x.png') no-repeat center center
  background-size: cover
  padding: 32px 0px 80px
  .main_title
    font-size: 24px
    font-weight: 900
    line-height: 25px
    color: rgba(51, 51, 51, 1)
    text-shadow: 0px 2px 1px rgba(29, 29, 29, 0.24)
    i
      display: block
      margin-top: 5px
      width: 73px
      height: 3px
      background: linear-gradient(90deg, rgba(225, 36, 26, 1), rgba(255, 164, 164, 1))
      box-shadow: 0px 2px 1px 0px rgba(29, 29, 29, 0.24)
  .circle
    display: inline-block
    wh(66px)
    line-height: 66px
    text-align: center
    background: linear-gradient(42deg, rgba(255, 120, 113, 1), rgba(250, 205, 173, 1))
    border-radius: 50%
    font-weight: bold
    color: #fff
    text-shadow: 0px 8px 15px rgba(137, 0, 0, 0.63)
  .main_box
    margin: 0px 45px
    position: relative
    > div
      width: 476px
      z-index: 0
      opacity: 0.3
      box-shadow: 0px 0px 26px 0px rgba(51, 51, 51, 0.5)
      background: #fff
      border-radius: 3px
      overflow: hidden
      > p
        border-top-left-radius: 3px
        border-top-right-radius: 3px
        hl(48px)
        text-align: center
        background: rgba(226, 71, 63, 1)
        font-size: 19px
        color: #fff
        > span
          display: inline-block
          width: 60px
          hl(18px)
          font-size: 12px
          color: #FFCCCC
          text-align: left
          right: 20px
        > span:after
          @extend .bablock
          @extend .paty
          btb(6px)
          right: 0px
          border-left: 8px solid #FFCCCC
      > div
        padding: 10px 52px 20px
        .main_tip
          margin: 15px 0px 52px
          > div
            width: 100%
            position: relative
            > div
              display: inline-block
            .text
              position: relative
              span
                display: inline-block
                width: 18px
                height: 18px
                line-height: 18px
                text-align: center
                color: #fff
                background-color: #E1241A
                border-radius: 50%
                position: relative
              span:after
                @extend .bablock
                @extend .palx
                btb(6px)
                blr(4px)
              > p
                position: absolute
                white-space: nowrap
                color: #666
                position: absolute
                left: 0
                line-height: 14px
            .line
              width: 100%
              height: 3px
              background: #FFE4E4
          > div:not(:first-child)
            .text > p
              @extend .palx
          > div:nth-child(2n-1)
            .text > span:after
              border-top: 6px solid #E1241A
              top: 16px
            .text > p
              top: 27px
              line-height: 18px
          > div:nth-child(2n)
            .text > span:after
              border-bottom: 6px solid #E1241A
              top: -10px
            .text > p
              top: -23px
          > div:last-child
            .line:after
              @extend .bablock
              @extend .paty
              right: 0px
              btb(6px)
              border-left: 8px solid #E1241A
        .main_btn > span
          display: inline-block
          cursor: pointer
          width: 146px
          hl(43px)
          background: linear-gradient(42deg, rgba(225, 46, 50, 1), rgba(255, 72, 0, 1))
          box-shadow: 0px 7px 12px 1px rgba(255, 11, 17, 0.4)
          border-radius: 22px
          color: #fff
          font-size: 14px
    > div.active
      z-index: 1
      opacity: 1
      vendor('transform', scale(1.2, 1.2))
      vendor('transition', all 1s)
  .main_rate
    background: url('~@/assets/img/home/BG_d@2x.png') no-repeat top left
    background-size: 85% 100%
    padding: 20px 0px 20px 26px
    .main_rate_tab
      width: 266px
      padding: 54px 0px
      > div
        width: 100%
        padding: 20px 38px 20px 0px
        color: #fff
        font-size: 14px
      > div:not(.active) span
        display: inline-block
        content: ''
        width: 2px
        height: 12px
        background-color: #D5D5D5
      .active
        padding-left: 20px
        background: linear-gradient(42deg, rgba(225, 46, 50, 1), rgba(255, 72, 0, 1))
        box-shadow: 0px 0px 5px 1px rgba(255, 0, 0, 0.64)
        font-weight: 700
        position: relative
      .active:after
        @extend .bablock
        @extend .paty
        right: -21px
        btb(20px)
        border-left: 22px solid #FE4501
    > div:last-child
      padding: 10px 40px 0px
      box-shadow: 4px 2px 13px 0px rgba(99, 99, 99, 0.5)
/* 资讯&公告 */
.informationAndNotice
  ul li:last-child
    border-bottom: none !important
  .title
    margin: 30px 0px 14px
    border-bottom: 1px solid #FFBDB9
    > span:first-child
      display: inline-block
      line-height: 30px
      font-weight: 700
      font-size: 20px
      border-bottom: 3px solid #E1241A
      padding-bottom: 8px
/* 合作机构 */
.title_hzjg
  text-align: center
  margin-bottom: 52px
  hl(45px)
  i
    display: inline-block
    width: 30px
    height: 2px
    background: rgba(102, 102, 102, 1)
  span
    vertical-align: middle
    margin: 0px 10px
    font-size: 36px
    font-weight: bold
    color: #E1241A
    text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.17)
#indexBottomBg
  width: 100px
  height: 140px
  position: fixed
  bottom: 0px
  left: 0px
  z-index: 31
  > img
    display: inline-block
    width: 100px
    position: absolute
    top: -14px
    cursor: pointer
    transition: left 0.5s ease 1s
  .logoAnimateHide
    transition: left 0.5s ease
    left: -96px
  .logoAnimateShow
    left: 0px
  > div
    width: 100%
    height: 140px
    position: fixed
    bottom: 0px
    left: -100%
    z-index: -1
    background-color: #111430
    transition: left 1s ease 0.5s
    > div
      display: block
      width: 100%
      height: 100%
      > div
        wh(100%)
        display: flex
        justify-content: center
        @extend .palx
        top: -10px
        img
          display: block
          max-width: 100%
          height: 150px
    span
      position: absolute
      left: 80%
      top: 45%
      width: 25px
      height: 25px
      border-radius: 50%
      background: #333 url('~@/assets/img/home/Close@2x.png') no-repeat center center
      background-size: 50%
      cursor: pointer
      transition: all 0.5s
    span:hover
      vendor('transform', rotate(180deg))
  .imgAnimateHide
    transition: left 1s ease
    left: -100%
  .imgAnimateShow
    left: 0px
</style>
<style lang="less" >
.filter {
  // 置灰滤镜
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue